import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-errors',
  templateUrl: './app-errors.component.html',
  styleUrls: ['./app-errors.component.scss'],
})
export class AppErrorsComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
